export const TemporaryKeyStatusType = {
  KEY_NOT_FOUND: "KEY_NOT_FOUND",
  NEW_EMAIL_NOT_FOUND: "NEW_EMAIL_NOT_FOUND",
  INVALID_EMAIL: "INVALID_EMAIL",
  USER_NOT_FOUND: "USER_NOT_FOUND",
  EXPIRED_KEY: "EXPIRED_KEY",
  USED_KEY: "USED_KEY",
  EXCEPTION: "EXCEPTION",
  SUCCESS: "SUCCESS",
};
